export default __webpack_public_path__ + "static/media/article1.786e077e.jpg";